import type {SubscriptionTier} from '../SubscriptionTier.js'
import type {Connection} from '../../connection/index.js'

export const validAmountOfConnectionsForTier = (tier: SubscriptionTier, activeConnections: number | Connection[]) => {
  const activeCount =
    typeof activeConnections === 'number'
      ? activeConnections
      : activeConnections.filter((connection) => !connection.deletionTime).length
  return activeCount <= tier.features.maxActiveConnections
}
